/* CYGNUSS 30/10/2026: zoom com legenda sobre o slider de antes e depois.
   Cada linha de data-cyg-zoom: x|y|lado|altura|texto antes|texto depois
   x, y e altura em % do quadro; lado l (esquerda) ou r (direita). */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  // as fotos do Flow têm detalhe real só até ~1400px: acima de ~2.4x a lupa só estica pixel e embaça
  var ZOOM = 2.4;

  function pontos(texto) {
    return String(texto || '')
      .split('\n')
      .map(function (linha) {
        var p = linha.split('|');
        if (p.length < 6) return null;
        return {
          x: parseFloat(p[0]),
          y: parseFloat(p[1]),
          lado: p[2].trim() === 'r' ? 'r' : 'l',
          cy: parseFloat(p[3]),
          antes: p[4].trim(),
          depois: p[5].trim(),
          // alvo próprio do Depois (colunas 7 e 8, opcionais): quando o mesmo ponto da foto não mostra o que a legenda diz
          xd: p.length > 7 && p[6].trim() !== '' ? parseFloat(p[6]) : parseFloat(p[0]),
          yd: p.length > 7 && p[7].trim() !== '' ? parseFloat(p[7]) : parseFloat(p[1]),
        };
      })
      .filter(Boolean);
  }

  function el(tag, classe) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    return e;
  }

  // seta tracejada curva de a até perto de b, com ponta fechada
  function seta(svg, a, b) {
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    var len = Math.sqrt(dx * dx + dy * dy);
    if (len < 14) return;
    var ux = dx / len;
    var uy = dy / len;
    var fim = { x: b.x - ux * 8, y: b.y - uy * 8 };
    var curva = len * 0.14;
    var c = { x: (a.x + fim.x) / 2 - uy * curva, y: (a.y + fim.y) / 2 + ux * curva };
    var corpo = document.createElementNS(NS, 'path');
    corpo.setAttribute('class', 'cyg-zoom__tracejado');
    corpo.setAttribute('d', 'M' + a.x + ' ' + a.y + ' Q' + c.x + ' ' + c.y + ' ' + fim.x + ' ' + fim.y);
    svg.appendChild(corpo);

    var tx = fim.x - c.x;
    var ty = fim.y - c.y;
    var tl = Math.sqrt(tx * tx + ty * ty) || 1;
    tx /= tl;
    ty /= tl;
    var ang = Math.PI / 7;
    function ponta(s) {
      var cos = Math.cos(s * ang);
      var sin = Math.sin(s * ang);
      return { x: fim.x - 9 * (tx * cos - ty * sin), y: fim.y - 9 * (tx * sin + ty * cos) };
    }
    var p1 = ponta(1);
    var p2 = ponta(-1);
    var cab = document.createElementNS(NS, 'path');
    cab.setAttribute('d', 'M' + p1.x + ' ' + p1.y + ' L' + fim.x + ' ' + fim.y + ' L' + p2.x + ' ' + p2.y);
    svg.appendChild(cab);
  }

  function iniciar(raiz) {
    if (raiz.dataset.cygZoomPronto) return;
    var envolucro = raiz.closest('[data-comparison-slider]');
    if (!envolucro || envolucro.dataset.orientation !== 'horizontal') return;
    var lista = pontos(raiz.dataset.cygZoom);
    if (!lista.length) return;
    raiz.dataset.cygZoomPronto = '1';

    var imgAntes = envolucro.querySelector('.before-image');
    var imgDepois = envolucro.querySelector('.after-image');
    var itens = [];

    function compare() {
      var v = parseFloat(getComputedStyle(envolucro).getPropertyValue('--compare'));
      return isNaN(v) ? 50 : v;
    }

    function geometria(img, W, H, x, y, d) {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      var escala = Math.max(W / nw, H / nh);
      var dw = nw * escala;
      var dh = nh * escala;
      var ox = (W - dw) / 2;
      var oy = (H - dh) / 2;
      return {
        tam: dw * ZOOM + 'px ' + dh * ZOOM + 'px',
        pos: d / 2 - (x / 100 * W - ox) * ZOOM + 'px ' + (d / 2 - (y / 100 * H - oy) * ZOOM) + 'px',
      };
    }

    // as duas camadas de cada lente ficam prontas; arrastar só troca uma classe, e só ao cruzar o ponto
    var agendado = false;
    function atualizar() {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () {
        agendado = false;
        var c = compare();
        itens.forEach(function (it) {
          var noAntes = it.pt.x < c;
          if (noAntes === it.noAntes) return;
          it.noAntes = noAntes;
          it.camAntes.style.visibility = noAntes ? 'visible' : 'hidden';
          it.camDepois.style.visibility = noAntes ? 'hidden' : 'visible';
          it.setaAntes.style.display = noAntes ? '' : 'none';
          it.setaDepois.style.display = noAntes ? 'none' : '';
          it.legenda.textContent = noAntes ? it.pt.antes : it.pt.depois;
        });
      });
    }

    // a lupa amplia 3,4x: precisa da versão maior do srcset, não da que o navegador escolheu para a tela
    function maior(img) {
      var melhor = img.currentSrc || img.src;
      var largura = 0;
      // o src do tema pede width=3840; com foto maior que 2752 o srcset para em 1920, então o src vence
      var m = /[?&]width=(\d+)/.exec(img.getAttribute('src') || '');
      if (m) {
        largura = parseInt(m[1], 10);
        melhor = img.getAttribute('src');
      }
      (img.getAttribute('srcset') || '').split(',').forEach(function (par) {
        var p = par.trim().split(/\s+/);
        var w = parseInt(p[1], 10);
        if (p[0] && w > largura) {
          largura = w;
          melhor = p[0];
        }
      });
      return melhor;
    }

    function camada(lente, img, g) {
      var cam = el('div', 'cyg-zoom__cam');
      cam.style.backgroundImage = 'url("' + maior(img) + '")';
      cam.style.backgroundSize = g.tam;
      cam.style.backgroundPosition = g.pos;
      lente.appendChild(cam);
      return cam;
    }

    function montar() {
      if (!imgAntes || !imgDepois || !imgAntes.naturalWidth || !imgDepois.naturalWidth) return;
      var W = envolucro.clientWidth;
      var H = envolucro.clientHeight;
      if (!W || !H) return;
      raiz.textContent = '';
      itens = [];
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'cyg-zoom__svg');
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      raiz.appendChild(svg);

      // celular: quadro pequeno, então lente maior e margem maior para o rótulo não encostar na borda
      var estreito = W < 560;
      var d = W * (estreito ? 0.18 : 0.2);
      var margem = W * (estreito ? 0.04 : 0.025);
      var rotulo = estreito ? 30 : 36; // altura do rótulo + respiro abaixo da lente
      lista.forEach(function (pt) {
        var item = el('div', 'cyg-zoom__item cyg-zoom__item--' + pt.lado);
        item.style.width = d + 'px';
        item.style[pt.lado === 'l' ? 'left' : 'right'] = margem + 'px';
        // o centro da lente é travado para lente e rótulo caberem inteiros no quadro
        var cyPx = Math.min(Math.max(pt.cy / 100 * H, d / 2 + 6), H - d / 2 - rotulo);
        item.style.top = cyPx - d / 2 + 'px';
        var lente = el('div', 'cyg-zoom__lente');
        var legenda = el('div', 'cyg-zoom__legenda');
        item.appendChild(lente);
        item.appendChild(legenda);
        raiz.appendChild(item);

        var cx = pt.lado === 'l' ? margem + d / 2 : W - margem - d / 2;
        var cy = cyPx;
        function setaPara(xp, yp) {
          var g = document.createElementNS(NS, 'g');
          svg.appendChild(g);
          var alvo = { x: xp / 100 * W, y: yp / 100 * H };
          var vx = alvo.x - cx;
          var vy = alvo.y - cy;
          var vl = Math.sqrt(vx * vx + vy * vy) || 1;
          seta(g, { x: cx + vx / vl * (d / 2 + 4), y: cy + vy / vl * (d / 2 + 4) }, alvo);
          return g;
        }

        itens.push({
          pt: pt,
          lente: lente,
          legenda: legenda,
          setaAntes: setaPara(pt.x, pt.y),
          setaDepois: setaPara(pt.xd, pt.yd),
          camAntes: camada(lente, imgAntes, geometria(imgAntes, W, H, pt.x, pt.y, d)),
          camDepois: camada(lente, imgDepois, geometria(imgDepois, W, H, pt.xd, pt.yd, d)),
          noAntes: null,
        });
      });
      atualizar();
      requestAnimationFrame(function () {
        raiz.classList.add('is-ready');
      });
    }

    [imgAntes, imgDepois].forEach(function (img) {
      if (img) img.addEventListener('load', montar);
    });
    if (window.ResizeObserver) new ResizeObserver(montar).observe(envolucro);
    // o componente do tema grava --compare no style do envolucro, ao arrastar e na animação de entrada
    new MutationObserver(atualizar).observe(envolucro, { attributes: true, attributeFilter: ['style'] });
    montar();
  }

  function varrer() {
    document.querySelectorAll('[data-cyg-zoom]').forEach(iniciar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();
  document.addEventListener('shopify:section:load', varrer);
})();
